import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { t } from '@/i18n';
import { Sparkles } from 'lucide-react';
import { HelpTip } from '@/components/ui/help-tip';

// Shows who produced an AI result: Claude (live) or a prepared demo answer.
export const AiBadge = ({ mode, className }) => {
  const live = mode === 'live';
  return (
    <span className={cn('inline-flex items-center gap-0.5', className)}>
      <Badge
        variant="outline"
      className={cn('gap-1 text-[10px] font-medium', live ? 'border-primary/40 text-primary' : 'text-muted-foreground')}
      title={t(live ? 'ai.liveHint' : 'ai.demoHint')}
    >
      <Sparkles className="h-3 w-3" /> {t(live ? 'ai.live' : 'ai.demo')}
    </Badge>
    <HelpTip id="ai" />
    </span>
  );
};
